import React from 'react'
import Newsletter from './NewsLetter'
import GetInTouch from './GetInTouch'
import Footer from './Footer'
import PartnerTop from './PartnerTop'
import ProductDes from './ProductDes'
import MainFeatures from './MainFeatures'
import Package from './Package'
import Productsdiv3 from './Productsdiv3'
import FeaturesGrid from './FeaturesGrid'
import WD2 from '../assets/WD-2.png'
import WebS1 from '../assets/WebS1.png';
import WebS2 from '../assets/WebS2.png';
import WebS3 from '../assets/WebS3.png';
import WebS5 from '../assets/WebS5.png';
import WebS4 from '../assets/WebS4.jpg';
import icon2 from '../assets/operation.png';
import icon3 from '../assets/webfinance.png';  // don't remove
import icon4 from '../assets/automation.png';
import realState from '../assets/realState.png';
import mf2 from '../assets/tourTravel.png';
import mf3 from '../assets/admission.png';
import mf4 from '../assets/transport.png';
import mf5 from '../assets/event.png';
import mf6 from '../assets/ecommerce.png';
import mf7 from '../assets/game.png';
import mf8 from '../assets/healthcare.png';
import mf9 from '../assets/study-material-upload.png';
import mf10 from '../assets/resturant.png';
import mf11 from '../assets/onDemand.png';
import mf12 from '../assets/Grocery.png';
import mf13 from '../assets/process-automation.png';
import mf14 from '../assets/automated-sms.png';
import mf15 from '../assets/basic-accounting.png';
import mf16 from '../assets/basic-utilities.png';
import WebDevDiv2 from './WebDevDiv2'
import WebDevDiv3 from './WebDevDiv3'
import WebDevServes from './WebDevServes'
import WebDevForm from './WebDevForm'

const WebsiteDev = () => {
  return (
    <div>
        <PartnerTop largeHeading="Website Development Company" smallHeading="Fostering Innovation and Creativity" btnText= "Let's Discuss Your Website" image={WD2}/>
      
      {/* <ProductDes largeHeading="WARALS Website Development Service" para1={<strong>Build, Grow, and Stand Out Online with Professional Website Solutions</strong>} para2=" WARALS Website Development Service is crafted to empower businesses, institutes, and training organizations with a strong and professional online presence. Designed with simplicity, scalability, and performance in mind, our service streamlines the process of getting your website live—whether you're starting from scratch or upgrading an existing platform." para3="Backed by a team of experienced developers and UI/UX specialists, our solutions are tailored to your brand’s identity and business goals. From dynamic content integration to SEO-ready structures, we ensure your website not only looks great but also works hard for you—driving engagement, visibility, and ultimately, growth."/> */}

      <WebDevDiv2/>

      <WebDevDiv3/>
      
     {/* <Productsdiv3 largeHeading="Why WARALS Website Development is Unique in Offerings" lightHeading="It is hard to find a complete website development solution that truly understands the unique needs of educational institutes and training organizations. Our service goes beyond just design—it focuses on functionality, user experience, and performance tailored specifically for the education sector. From inquiry forms to course showcases, we integrate everything you need in one seamless platform, eliminating the hassle of juggling multiple vendors or tools. It's a smart, efficient way to build your digital presence with ease and confidence." /> */}

        <FeaturesGrid  hasHeading={true}
                features={[
                    {
                        id: 1,
                        title: "Custom Web Designing",
                        description:
                            "Warals Technology offers websites that improve your online presence. Our designers are experts at creating user-friendly websites that connect businesses with their customers.",
                        icon: WebS4,
                    },
                    {
                        id: 2,
                        title: "Website Redesign",
                        description:
                            "Your site is looking a little stale, and you think it's time for a refresh, or you'd like to rework the user experience to address a problem like stagnant traffic and dropping conversions.",
                        icon: WebS3,
                    },
                   
                    {
                        id: 4,
                        title: "Responsive Website Designing",
                        description:
                            "Responsive web design is a method of web development that alters the appearance of a website based on the screen size and orientation of the device being used to view it.",
                        icon:WebS1,
                    },
                    {
                        id: 5,
                        title: "Ecommerce Website Designing",
                        description:
                            "Ecommerce web design is all about using the proper colours, fonts, images, phrases, and graphics to persuade visitors to make a purchase while also providing functionality to manage your products or services from your admin dashboard.",
                        icon:WebS5,
                    },
                ]}
            />

            <WebDevServes
            hasHeading={"We Serve the Following Industries"}
            features={[
                {
                    title: 'Real Estate',
                    // description: 'Entry of Leads details and management',
                    icon: realState
                },
                {
                    title: 'Tour & Travels',
                    // description: 'No Missed Follow ups for more conversions',
                    icon: mf2
                },
                {
                    title: 'Education',
                    // description: 'Admissions conversion directly from Enquiry',
                    icon: mf3
                },
                

                 {
                    title: 'Event',
                    // description: 'Role based access for employee/users',
                    icon: mf5
                },
                 {
                    title: 'eCommerce',
                    // description: 'Batch wise Students assignment and attendance',
                    icon: mf6
                },
                 
                 {
                    title: 'Healthcare',
                    // description: 'Module wise Course tracker for better scheduling',
                    icon: mf8
                },
                
                 {
                    title: 'Resturant',
                    // description: 'Admin can upload leads in bulk through excel for time savings',
                    icon: mf10
                },
                 
                 {
                    title: 'Grocery',
                    // description: 'Various MIS reports exportable in Excel and PDF format',
                    icon: mf12
                },
            


            ]} />

             

      {/* <Newsletter/> */}
      {/* <GetInTouch/> */}
      <WebDevForm/>
      <Footer/>
    </div>
  )
}

export default WebsiteDev;
